import * as React from 'react';
import { Button, makeStyles, tokens, Tooltip } from '@fluentui/react-components';
import { EditType, getRedliningEditTypes } from '../../services/editTypes';

interface RedliningPaletteProps {
  disabled: boolean;
  onSelect: (editType: EditType) => void;
}

const useStyles = makeStyles({
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    marginBottom: '8px',
  },
  chip: {
    minWidth: 'auto',
    padding: '4px 10px',
    fontSize: tokens.fontSizeBase200,
  },
});

const RedliningPalette: React.FC<RedliningPaletteProps> = ({ disabled, onSelect }) => {
  const styles = useStyles();
  const editTypes = getRedliningEditTypes();

  return (
    <div className={styles.grid}>
      {editTypes.map(editType => (
        <Tooltip key={editType.id} content={editType.description} relationship="description">
          <Button
            className={styles.chip}
            size="small"
            appearance="secondary"
            disabled={disabled}
            onClick={() => onSelect(editType)}
          >
            {editType.label}
          </Button>
        </Tooltip>
      ))}
    </div>
  );
};

export default RedliningPalette;
